<template>
    <!-- 生活消费 2  -->
    <sub-page :title="title" :subtitle="subtitle" :description="description" :button-text="buttonText" :bg="bg"
        :right-bg="rightBg" :right-bg2="rightBg2" :rbg2Style="{ transform: 'rotateZ(-20deg)' }" :partition="[7, 5]" />
</template>

<script>
import SubPage from '@/views/components/SubPage.vue'
export default {
    name: 'life-two',
    components: {
        SubPage
    },
    data() {
        return {
            bg: "/img/pay/0--36.png",
            rightBg: "/img/pay/0--69.png",
            rightBg2: "/img/pay/0--70.png"
        }
    },
    computed: {
        title() {
            return this.$t('life.title');
        },
        subtitle() {
            return this.$t('lifeTwo.subtitle');
        },
        description() {
            const desc = this.$t('lifeTwo.description');
            return Array.isArray(desc) ? desc : [desc];
        },
        buttonText() {
            return this.$t('common.buttonText');
        },
    }
}
</script>